import { BaseDto } from './base.dto';

export class ReviewSourceTypeDto extends BaseDto {
  productName?: string;
  currency?: string;
  price?: number;
  effectiveFrom?: Date;
}